// import { newContext } from 'immutability-helper';
import * as immutability from 'immutability-helper';
import concat from 'lodash/concat';
import differenceWith from 'lodash/differenceWith';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import uniqWith from 'lodash/uniqWith';

/**
 * See immutability-helper documentation for all default operations
 * https://github.com/kolodny/immutability-helper#available-commands
 *
 */
export const update = immutability.default.newContext();
/**
 * Remove all given values from the array.
 *
 * @param value An array or single value to be removed from the original
 */
update.extend('$arrayRemove', function (value, original) {
  value = isArray(value) ? value : [value];
  return differenceWith(original, value, isEqual);
});

/**
 * Push all unique values to the array if those values don't already exist
 *
 * @param value An array or single value to be removed from the original
 */
update.extend('$arrayUniquePush', function (value, original) {
  value = isArray(value) ? value : [value];
  const newUniqueValues = uniqWith(differenceWith(value, original, isEqual), isEqual);
  return concat(original, newUniqueValues);
});

/**
 * Keep only the keys passed to it from the object. Kind-of the inverse of $unset
 *
 * @param value An array or single value as a key to be kept in the original object
 */
update.extend('$keep', function (value, original) {
  value = isArray(value) ? value : [value];
  return pick(original, value);
});
